import React, { ReactNode } from 'react';
type ContainerProps = {
  children: ReactNode;
  className?: string;
};
export function Container({
  children,
  className = ''
}: ContainerProps) {
  return <div className={`mx-auto w-full max-w-[1120px] px-5 sm:px-[22px] ${className}`} data-id="element-39" data-mp="3bil1u1gp5cfv">
      {children}
    </div>;
}